export const CATEGORY_TYPES = {
    DRINK: 'Drink',
    PRODUCT: 'Product',
    MENU: 'Menu',
    Business: 'Business',
    MASTER: 'Master',
    CUSTOM: 'Custom',
} as const;
export type CategoryType = (typeof CATEGORY_TYPES)[keyof typeof CATEGORY_TYPES];
